module.exports = __webpack_public_path__ + "static/media/hero-boucher.6396df2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/hero-boucher.jpg
// module id = 200
// module chunks = 51